import { NavLink } from "react-router-dom";
import { useState } from "react";
import "./Navbar.css"; // Deine CSS-Datei importieren
import { FaCog } from "react-icons/fa"; // Zahnrad-Icon importieren
import SettingsMenu from "../pages/SettingsMenu"; // Update the path to the correct location
import { useEffect, useRef } from "react";


export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false); // Zustand für Settings-Menü

  return (
    <nav>
      <div className="app-title">GymDich</div>
      <div className="menu" onClick={() => {
        setMenuOpen(!menuOpen)
        setSettingsOpen(false)
        }}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <ul className={menuOpen ? "nav-links open" : "nav-links"}>
        <li>
          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/aboutme"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            AboutMe
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/news"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            News
          </NavLink>
        </li>
        <li>
          {/* Icon für Einstellungen hinzufügen */}
          <FaCog
            className="settings-icon"
            onClick={() => {
              setSettingsOpen(!settingsOpen)
              setMenuOpen(false)
            }}
          />
        </li>
      </ul>
      {settingsOpen && <SettingsMenu />} {/* SettingsMenu anzeigen */}
    </nav>
  );
};